import { render, staticRenderFns } from "./InterlocuteurForm.vue?vue&type=template&id=27f5f54b&"
import script from "./InterlocuteurForm.vue?vue&type=script&lang=js&"
export * from "./InterlocuteurForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports